import axios from "axios";
import store from "../store";
import { action as ActionList } from "@/assets/json/logger";
import moment from "moment";
import BrandKey from "@/assets/json/logbrand";
import VueCookies from "vue-cookies";
import { appConfig } from "../aLwAJXh7rUuwykLl";
const serializeRequestValue = value => {
  if (value == null || typeof value === "string") return value;

  try {
    return JSON.stringify(value);
  } catch (error) {
    return String(value);
  }
};

const buildRequestBody = config => {
  const metadata = config.metadata || {};
  const body = serializeRequestValue(
    metadata.requestBody !== undefined ? metadata.requestBody : config.data
  );
  const params = serializeRequestValue(
    metadata.requestParams !== undefined
      ? metadata.requestParams
      : config.params
  );

  if (!params || params === "{}") return body;

  return JSON.stringify({ body: body || "", params });
};

const successfulActions = [
  {
    method: "POST",
    path: /^\/api\/v1\/reward\/redeem_coupon\/auto_mark_use$/i,
    action: "COUPON_AUTO_MARK_USE",
    note: "เริ่มใช้งาน coupon",
    fields: ["promotion_id", "user_coupon_id"]
  },
  {
    method: "POST",
    path: /^\/api\/v1\/reward\/redeem_coupon\/\d+$/i,
    action: "COUPON_REDEEM",
    note: "ยืนยันการใช้งาน coupon",
    fields: ["promotion_id", "user_coupon_id", "branch_id"]
  },
  {
    method: "POST",
    path: /^\/api\/v1\/privilege\/redeemprivilege$/i,
    action: "COUPON_CODE_REDEEM",
    note: "ยืนยันกรอก coupon code",
    fields: []
  },
  {
    method: "POST",
    path: /^\/api\/v1\/redeem\/redeem_item$/i,
    action: "REDEEM_PICKUP",
    note: "ยืนยันแลกรางวัลรับที่สาขา",
    fields: ["redeem_id", "product_id", "branch_id", "redeem_count"]
  },
  {
    method: "POST",
    path: /^\/api\/v1\/redeem\/redeem_pick_at_home$/i,
    action: "REDEEM_HOME_DELIVERY",
    note: "ยืนยันแลกรางวัลส่งถึงบ้าน",
    fields: ["redeem_id", "product_id", "redeem_count"]
  },
  {
    method: "POST",
    path: /^\/api\/v1\/user\/connect\/marketplace$/i,
    action: "MARKETPLACE_CONNECT",
    note: "เชื่อมต่อ marketplace สำเร็จ",
    fields: ["branch_id", "sales_channel_id"]
  },
  {
    method: "DELETE",
    path: /^\/api\/v1\/user\/delete\/marketplace\/\d+$/i,
    action: "MARKETPLACE_DISCONNECT",
    note: "ตัดการเชื่อมต่อ marketplace สำเร็จ",
    fields: []
  }
];

const safeActionBody = (config, fields) => {
  const requestBody = config.metadata?.requestBody ?? config.data;
  let body = requestBody;
  if (typeof body === "string") {
    try {
      body = JSON.parse(body);
    } catch (_) {
      body = null;
    }
  }

  const safeBody = {};
  for (const field of fields) {
    const value = body?.[field];
    if (
      (typeof value === "number" && Number.isFinite(value)) ||
      (typeof value === "string" && /^\d+$/.test(value))
    ) {
      safeBody[field] = value;
    }
  }
  return JSON.stringify(safeBody);
};

const logActionSuccess = response => {
  try {
    const config = response.config || {};
    const method = (config.method || "").toUpperCase();
    const path = new URL(config.url, window.location.origin).pathname;
    const action = successfulActions.find(
      entry => entry.method === method && entry.path.test(path)
    );
    if (!action || response.status < 200 || response.status >= 300) return;
    if (response.data?.result != 1) return;

    const startTime = config.metadata?.startTime;
    const start = startTime ? new Date(startTime) : new Date();
    const duration = Math.max(0, Date.now() - start.getTime());
    const brand = window.location.hostname.split("-")[0];
    const key = BrandKey.find(el => el.brand.toLowerCase() == brand);
    const payload = {
      LogLevelId: 2,
      Menu: window.location.pathname.replace("/", " ").trim(),
      Action: action.action,
      DeviceOS: window.navigator.platform,
      DeviceType: window.navigator.userAgent,
      UserGUID: store.state.shortProfile?.user_guid || "",
      Method: method,
      Url: path,
      ResponseCode: response.status,
      Body: safeActionBody(config, action.fields),
      ResponseBody: JSON.stringify({ result: 1 }),
      RequestTime: start.toISOString(),
      ResponseTime: moment.utc(duration).format("HH:mm:ss.SSS"),
      Note: action.note
    };

    axios
      .post(`${appConfig.VUE_APP_LOGGER_API}/Log`, payload, {
        headers: {
          "api-key": key ? key.key : "Cmd9Fk3QosXlakF0gMkeQ9fASogF"
        }
      })
      .catch(error => {
        console.error("Action success logging failed:", error.message);
      });
  } catch (error) {
    console.error("Action success logger error:", error.message);
  }
};

const logger = ({ response, action }) => {
  try {
    let location = window.location.hostname;
    let brand = location.split("-")[0];
    let config = response.config || {};

    let start;
    let duration;
    let path = window.location.pathname.replace("/", " ").trim();
    if (config.metadata) {
      config.metadata.endTime = new Date();
      start = moment(config.metadata.startTime).utcOffset(7);

      let end = moment(config.metadata.endTime);
      duration = moment
        .utc(moment(end).diff(moment(start)))
        .format("HH:mm:ss.SSS");
    }

    if (!action) {
      action = ActionList.find(
        el =>
          config.url &&
          config.url.includes(el.url) &&
          (el.path == "" || el.path == window.location.pathname)
      );
    }
    if (
      (config.url == "/api/v1/user/LoginExternal" ||
        config.url == "/api/v1/user/CheckSocialBind") &&
      response.status == 200
    )
      return;
    let responseBody =
      response.status == 200 || response.status < 500
        ? JSON.stringify({
            token: VueCookies.isKey("token") ? VueCookies.get("token") : "",
            socialProvider: VueCookies.isKey("user_profile_token")
              ? VueCookies.get("user_profile_token")
              : "",
            body: response.data
          })
        : JSON.stringify({
            token: VueCookies.isKey("token") ? VueCookies.get("token") : "",
            socialProvider: VueCookies.isKey("user_profile_token")
              ? VueCookies.get("user_profile_token")
              : ""
          });
    let actionName = action ? action.action : "";
    let actionId = action ? action.id : 2;
    let payload = {
      LogLevelId: actionId,
      Menu: path,
      Action: actionName,
      DeviceOS: window.navigator.platform,
      DeviceType: window.navigator.userAgent,
      UserGUID: store.state.shortProfile.user_guid || "",
      Method: config.method,
      Url: config.url,
      ResponseCode: response.status,
      Body: buildRequestBody(config),
      ResponseBody: responseBody,
      RequestTime: start
        ? start && start.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
        : moment().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
      ResponseTime: duration ? duration.toString() : "0",
      Note: action ? action.note : ""
    };

    const key = BrandKey.find(el => el.brand.toLowerCase() == brand);
    axios.post(`${appConfig.VUE_APP_LOGGER_API}/Log`, payload, {
      headers: {
        "api-key": key ? key.key : "Cmd9Fk3QosXlakF0gMkeQ9fASogF"
      }
    });
  } catch (error) {
    console.error("logger error:", error);
  }
};

export { logger, logActionSuccess };
